/*
 * Marks the cells that sit in the first column of each table so CSS can make them
 * sticky. `tr > :first-child` is wrong whenever a rowspan cell spans into the next row,
 * because that row's first child is really the second column.
 */
(function () {
  function markFirstColumn(table) {
    var reserved = [];

    Array.prototype.forEach.call(table.rows, function (row, rowIndex) {
      var col = 0;
      var taken = reserved[rowIndex] || {};

      Array.prototype.forEach.call(row.cells, function (cell) {
        while (taken[col]) col += 1;

        if (col === 0) cell.setAttribute('data-first-col', '');

        var rowSpan = cell.rowSpan || 1;
        var colSpan = cell.colSpan || 1;

        for (var r = 1; r < rowSpan; r += 1) {
          reserved[rowIndex + r] = reserved[rowIndex + r] || {};
          for (var c = col; c < col + colSpan; c += 1) reserved[rowIndex + r][c] = true;
        }

        col += colSpan;
      });
    });
  }

  document
    .querySelectorAll('.content-selector__content--mobile-table table')
    .forEach(markFirstColumn);
})();
